export default "__VITE_ASSET__DElfEkWT__"